<template>
  <div>
    <v-row>
      <v-col 
        cols="12" 
        md="9"
        class="py-0">
        <!-- <v-card
          outlined
          class="pa-2 mb-4"
          style="border-radius: 10px;">
          <swiper 
            class="swiper"
            ref="swiper"
            :options="{ slidesPerView: 'auto' }">
            <swiper-slide 
              class="pr-3"
              style="width: auto;">
              <v-btn
                to="/officer"
                large
                color="#388E3C"
                class="text-capitalize white--text px-0"
                min-width="45"
                min-height="45"
                style="border-radius: 10px; 
                      box-shadow: rgba(0, 0, 0, 0.35) 0px -50px 36px -28px inset;">
                <v-avatar 
                  color="#388E3C" 
                  size="30"
                  style="box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;">
                  <v-icon>mdi-plus-thick</v-icon>
                </v-avatar>
              </v-btn>
            </swiper-slide>
            
            <swiper-slide 
              v-for="(item, index) in process.user ? 20 : list.user" 
              :key="index" 
              :class="index < 1 ? 'pr-3' : index < list.user.length ? 'pr-3' : 'px-3'"
              style="width: auto;">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.user"
                type="avatar"
                tile>
                <div>
                  <v-card v-if="!process.user && list.user.length > 0"
                    :to="`/user/${item.id}`"
                    flat
                    color="transparent"
                    class="border-radius d-flex align-center justify-center">
                    <div 
                      class="text-center"
                      style="width: 45px;">
                      <v-avatar 
                        size="45" 
                        tile>
                        <v-img 
                          alt="amanata" 
                          :src="item.image_url === '' ? require('@/assets/image/member_default.jpg') : item.image_url"
                          class="ma-auto"
                          style="border-radius: 10px;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="white">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>

                      <div
                        class="caption one-line mt-1"
                        style="opacity: 60%;">
                        {{ item.name }}
                      </div>
                    </div>
                  </v-card>
                </div>
              </v-skeleton-loader>
            </swiper-slide>
          </swiper>
        </v-card> -->

        <v-row>
          <v-col 
            cols="12" 
            md="4">
            <v-card
              min-height="175"
              class="border-radius"
              color="#FFFFFF"
              style="box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.dashboard"
                type="image">
                <v-card-text>
                  <div
                    class="d-flex align-start">
                    <div>
                      <div class="body-1 black--text font-weight-bold">
                        Total Laporan
                      </div>

                      <div 
                        class="caption d-flex align-center mb-12">
                        <v-icon small>mdi-file-sign</v-icon>
                        
                        <span
                          class="ml-1">
                          Total data laporan
                        </span>
                      </div>
                    </div>

                    <v-spacer />

                    <div>
                      <v-img 
                        width="60"
                        height="60"
                        alt="amanata" 
                        :src="require(`@/assets/image/time/${isDay}.png`)"
                        class="ma-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="white">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>
                  </div>

                  <div class="d-flex align-center">
                    <div class="d-flex align-end">
                      <span 
                        class="text-h3 black--text font-weight-bold">
                        {{ count.total_laporan | number }}
                      </span>

                      <!-- <v-icon 
                        size="28" 
                        color="green" 
                        class="mb-1">
                        mdi-arrow-up-thick
                      </v-icon>

                      <span 
                        class="font-weight-bold mb-1 green--text">
                        5%
                      </span> -->
                    </div>

                    <v-spacer />

                    <div class="black--text">
                      <div v-if="clock.time.length > 0">
                        <div 
                          class="caption" 
                          style="opacity: 60%;">
                          {{ clock.date | date }}
                        </div>

                        <div 
                          class="body-1 font-weight-bold">
                          {{ clock.time }}
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-skeleton-loader>
            </v-card>
          </v-col>
          
          <v-col 
            cols="12" 
            md="4">
            <v-card
              min-height="175"
              class="border-radius"
              color="#FFFFFF"
              style="box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.dashboard"
                type="image">
                <v-card-text
                  class="pb-1">
                  <div
                    class="d-flex align-start">
                    <div>
                      <v-avatar
                        tile
                        size="50"
                        color="#388e3c1a"
                        style="border-radius: 15px !important;">
                        <v-icon size="30" color="#388E3C">mdi-account-multiple-check-outline</v-icon>
                      </v-avatar>
                    </div>

                    <v-spacer />

                    <div>
                      <span
                        class="mr-1">
                        Lihat
                      </span>
                      
                      <router-link
                        to="/officer">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </router-link>
                    </div>
                  </div>
                </v-card-text>

                <v-card-text>
                  <div
                    class="body-2 mb-3">
                    Pegawai Aktif
                  </div>

                  <div
                    class="text-h4 font-weight-bold black--text">
                    {{ count.total_active | number }}
                  </div>
                </v-card-text>
              </v-skeleton-loader>
            </v-card>
          </v-col>

          <v-col 
            cols="12" 
            md="4">
            <v-card
              min-height="175"
              class="border-radius"
              color="#FFFFFF"
              style="box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.dashboard"
                type="image">
                <v-card-text
                  class="pb-1">
                  <div
                    class="d-flex align-start">
                    <div>
                      <v-avatar
                        tile
                        size="50"
                        color="#388e3c1a"
                        style="border-radius: 15px !important;">
                        <v-icon size="30" color="#388E3C">mdi-account-multiple-remove-outline</v-icon>
                      </v-avatar>
                    </div>

                    <v-spacer />

                    <div>
                      <span
                        class="mr-1">
                        Lihat
                      </span>
                      
                      <router-link
                        to="/officer">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </router-link>
                    </div>
                  </div>
                </v-card-text>

                <v-card-text>
                  <div
                    class="body-2 mb-3">
                    Pegawai Non Aktif
                  </div>

                  <div
                    class="text-h4 font-weight-bold black--text">
                    {{ count.total_not_active | number }}
                  </div>
                </v-card-text>
              </v-skeleton-loader>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            md="9">
            <v-card
              flat
              color="#f9f9f9"
              class="border-radius">
              <v-card-title 
                class="body-1 font-weight-bold black--text">
                Grafik Presensi
              </v-card-title>

              <v-card-subtitle 
                class="caption pb-0 d-flex align-center">
                <v-icon small>mdi-chart-line</v-icon>
                
                <span
                  class="ml-1">
                  Sampai Dengan <b>{{ clock.date | date }}</b>
                </span>
              </v-card-subtitle>

              <v-card-text
                class="pr-2"
                :class="process.grafik ? 'pa-4' : 'pa-0'">
                <v-skeleton-loader
                  class="ma-auto"
                  :loading="process.grafik"
                  type="image">
                  <div>
                    <div v-if="!process.grafik && Object.keys(this.list.bar).length > 0">
                      <apexchart 
                        height="375" 
                        :options="list.bar.chartOptions" 
                        :series="list.bar.series">
                      </apexchart>
                    </div>
                  </div>
                </v-skeleton-loader>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="3">
            <v-card
              flat
              color="#f9f9f9"
              class="border-radius">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.dashboard"
                type="image, article">
                <v-card-text 
                  class="text-center mb-4">
                  <div
                    class="body-1 font-weight-bold black--text">
                    Persentase Pegawai
                  </div>
                  
                  <div
                    class="caption"
                    style="opacity: 70%;">
                    Sampai Dengan <b>{{ clock.date | date }}</b>
                  </div>
                </v-card-text>

                <v-card-text
                  class="text-center">
                  <v-progress-circular
                    :rotate="360"
                    :size="175"
                    :width="12"
                    :value="(count.total_active / count.total_pegawai) * 100"
                    color="#388E3C">
                    <div
                      class="text-h4">
                      {{ ((count.total_active / count.total_pegawai) * 100).toFixed(1) }}%
                    </div>
                  </v-progress-circular>
                </v-card-text>

                <v-card-text>
                  <div
                    class="body-2 black--text line-text-first text-center my-2"
                    style="opacity: 60%;">
                    Berikut persentase pegawai aktif dan tidak aktif
                  </div>

                  <v-row>
                    <v-col
                      cols="6">
                      <div
                        class="d-flex align-center">
                        <div>
                          <v-avatar
                            tile
                            size="36"
                            color="#388e3c1a"
                            style="border-radius: 10px !important;">
                            <v-icon size="20" color="#388E3C">mdi-account-multiple-check-outline</v-icon>
                          </v-avatar>
                        </div>

                        <div
                          class="nody-2 font-weight-bold ml-3">
                          {{ ((count.total_active / count.total_pegawai) * 100).toFixed(1) }}%
                        </div>
                      </div>
                    </v-col>

                    <v-col
                      cols="6">
                      <div
                        class="d-flex align-center">
                        <div>
                          <v-avatar
                            tile
                            size="36"
                            color="#388e3c1a"
                            style="border-radius: 10px !important;">
                            <v-icon size="20" color="#388E3C">mdi-account-multiple-remove-outline</v-icon>
                          </v-avatar>
                        </div>

                        <div
                          class="nody-2 font-weight-bold ml-3">
                          {{ ((count.total_not_active / count.total_pegawai) * 100).toFixed(1) }}%
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-skeleton-loader>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            md="3"
            class="pb-0">
            <v-card
              min-height="180"
              class="border-radius"
              color="#FFFFFF"
              style="box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.dashboard"
                type="image">
                <v-card-text
                  class="pb-1">
                  <div
                    class="d-flex align-start">
                    <div>
                      <v-avatar
                        tile
                        size="50"
                        color="#388e3c1a"
                        style="border-radius: 15px !important;">
                        <v-icon size="30" color="#388E3C">mdi-account-group-outline</v-icon>
                      </v-avatar>
                    </div>

                    <v-spacer />

                    <div>
                      <span
                        class="mr-1">
                        Lihat
                      </span>
                      
                      <router-link
                        to="/officer">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </router-link>
                    </div>
                  </div>
                </v-card-text>

                <v-card-text>
                  <div
                    class="body-2 mb-3">
                    Total Pegawai
                  </div>

                  <div
                    class="text-h4 font-weight-bold black--text">
                    {{ count.total_pegawai | number }}
                  </div>
                </v-card-text>
              </v-skeleton-loader>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="3"
            class="pb-0">
            <v-card
              min-height="180"
              class="border-radius"
              color="#FFFFFF"
              style="box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.dashboard"
                type="image">
                <v-card-text
                  class="pb-1">
                  <div
                    class="d-flex align-start">
                    <div>
                      <v-avatar
                        tile
                        size="50"
                        color="#388e3c1a"
                        style="border-radius: 15px !important;">
                        <v-icon size="30" color="#388E3C">mdi-account-check-outline</v-icon>
                      </v-avatar>
                    </div>

                    <v-spacer />

                    <div>
                      <span
                        class="mr-1">
                        Lihat
                      </span>
                      
                      <router-link
                        to="/attendance">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </router-link>
                    </div>
                  </div>
                </v-card-text>

                <v-card-text>
                  <div
                    class="body-2 mb-3">
                    Presensi Hadir
                  </div>

                  <div
                    class="text-h4 font-weight-bold black--text">
                    {{ count.total_hadir | number }}
                  </div>
                </v-card-text>
              </v-skeleton-loader>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="3"
            class="pb-0">
            <v-card
              min-height="180"
              class="border-radius"
              color="#FFFFFF"
              style="box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.dashboard"
                type="image">
                <v-card-text
                  class="pb-1">
                  <div
                    class="d-flex align-start">
                    <div>
                      <v-avatar
                        tile
                        size="50"
                        color="#388e3c1a"
                        style="border-radius: 15px !important;">
                        <v-icon size="30" color="#388E3C">mdi-ballot-outline</v-icon>
                      </v-avatar>
                    </div>

                    <v-spacer />

                    <div>
                      <span
                        class="mr-1">
                        Lihat
                      </span>
                      
                      <router-link
                        to="/licensing/permission">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </router-link>
                    </div>
                  </div>
                </v-card-text>

                <v-card-text>
                  <div
                    class="body-2 mb-3">
                    Izin & Cuti
                  </div>

                  <div
                    class="text-h4 font-weight-bold black--text">
                    {{ count.total_ijin | number }}
                  </div>
                </v-card-text>
              </v-skeleton-loader>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="3"
            class="pb-0">
            <v-card
              min-height="180"
              class="border-radius"
              color="#FFFFFF"
              style="box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.dashboard"
                type="image">
                <v-card-text
                  class="pb-1">
                  <div
                    class="d-flex align-start">
                    <div>
                      <v-avatar
                        tile
                        size="50"
                        color="#388e3c1a"
                        style="border-radius: 15px !important;">
                        <v-icon size="30" color="#388E3C">mdi-account-cancel-outline</v-icon>
                      </v-avatar>
                    </div>

                    <v-spacer />

                    <div>
                      <span
                        class="mr-1">
                        Lihat
                      </span>
                      
                      <router-link
                        to="/attendance">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </router-link>
                    </div>
                  </div>
                </v-card-text>

                <v-card-text>
                  <div
                    class="body-2 mb-3">
                    Presensi Alpa
                  </div>

                  <div
                    class="text-h4 font-weight-bold black--text">
                    {{ count.total_alpa | number }}
                  </div>
                </v-card-text>
              </v-skeleton-loader>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col 
        cols="12" 
        md="3"
        class="py-0">
        <v-card
          flat
          color="#388E3C0d"
          class="border-radius"
          min-height="calc(100vh - 110px)">
          <v-card-text>
            <v-card
              class="border-radius mb-10"
              color="#fff"
              style="box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.dashboard"
                type="article, list-item-two-line">
                <v-card-text>
                  <div>
                    <div 
                      class="body-1 black--text font-weight-bold">
                      Izin & Cuti
                    </div>

                    <div 
                      class="caption d-flex align-center mb-6">
                      Pengajuan Pegawai
                    </div>

                    <v-progress-linear
                      v-model="count.total_cuti_approved"
                      color="#388E3C"
                      height="15"
                      style="border-radius: 50px;">
                    </v-progress-linear>

                    <div
                      class="body-2 black--text font-weight-bold text-center mt-6"
                      style="opacity: 80%;">
                      Ajuan Di Proses
                    </div>

                    <div
                      class="caption black--text text-center mb-4"
                      style="opacity: 60%;">
                      Lihat selengkapnya ?
                    </div>

                    <v-btn
                      to="/licensing/submission"
                      block
                      color="#388E3C"
                      elevation="0"
                      class="text-capitalize font-weight-bold white--text"
                      style="border-radius: 10px;">
                      Ajukan Izin & Cuti
                    </v-btn>
                  </div>
                </v-card-text>
              </v-skeleton-loader>
            </v-card>

            <div
              class="body-1 font-weight-bold black--text mt-12 mb-1">
              Data Izin & Cuti
            </div>

            <div
              class="body-2 mb-4">
              Berikut data Izin & Cuti sampai hari ini:
            </div>

            <v-list
              class="mb-5"
              color="transparent">
              <v-skeleton-loader
                v-for="(item, index) in process.dashboard ? 5 : list.todo"
                :key="index"
                class="ma-auto"
                :loading="process.user"
                type="list-item-avatar-two-line">
                <v-list-item
                  class="pa-0 mb-2">
                  <v-list-item-avatar
                    tile
                    size="45"
                    color="#388e3c1a"
                    class="mr-3"
                    style="border-radius: 15px !important;">
                    <v-icon
                      color="#388E3C">
                      {{ item.icon }}
                    </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title
                      class="body-2 font-weight-bold black--text mb-1"
                      style="opacity: 80%;">
                      {{ item.name }}
                    </v-list-item-title>

                    <v-list-item-subtitle
                      class="caption black--text"
                      style="opacity: 60%;">
                      Jumlah {{ item.count | number }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-skeleton-loader>
            </v-list>

            <div
              class="body-1 font-weight-bold black--text mb-4">
              Pengumuman
            </div>

            <v-card
              class="border-radius"
              color="#fff"
              min-height="140"
              style="box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.announcement"
                type="article">
                <div>
                  <v-card-text v-if="!process.announcement && list.announcement.length > 0"
                    class="d-flex align-start">
                    <v-icon x-small color="#388E3C" class="my-6">mdi-circle</v-icon>

                    <div
                      class="ml-4">
                      <div>
                        <div 
                          class="body-2 black--text font-weight-bold">
                          {{ list.announcement[0].title }}
                        </div>

                        <div 
                          class="caption d-flex align-center mb-2">
                          {{ list.announcement[0].input_datetime | date }}
                        </div>

                        <div
                          class="body-2 black--text line-text-first three-line"
                          style="opacity: 60%;">
                          {{ list.announcement[0].desc }}
                        </div>
                      </div>
                    </div>
                  </v-card-text>

                  <v-card-text v-else
                    class="text-center py-14">
                    Belum ada Pengumuman!!!
                  </v-card-text>
                </div>
              </v-skeleton-loader>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        clock: {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          time: ''
        },
        count: {},
        list: {
          user: [],
          todo: [],
          bar: {},
          announcement: []
        },
        pagination: {
          user: {}
        },
        process: {
          user: false,
          grafik: false,
          dashboard: false,
          announcement: false
        }
      }
    },
    components: {
      
    },
    computed: {
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      }
    },
    watch: {
      
    },
    mounted () {
      setInterval(this.updateTime, 1000)
      
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchUser()
        this.fetchGrafik()
        this.fetchCount()
        this.fetchAnnouncement()
      },
      async fetchUser () {
        this.process.user = true
        
        let params = {
          limit: 20
        }

        await get(`admin/user`, { params })
        .then(response => {
          let res = response.data

          this.process.user = false

          if (res.status === 200) {
            this.list.user = res.results.data
            this.pagination.user = res.results.pagination
          }
        })
      },
      async fetchGrafik () {
        this.process.grafik = true
        
        let params = {
          year: '2023'
        }

        await get(`admin/dashboard/grafik`, { params })
        .then(response => {
          let res = response.data

          this.process.grafik = false

          if (res.status === 200) {
            this.list.bar = {
              series: res.results.data,
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                stroke: {
                  width: 3,
                  curve: 'smooth'
                },
                dataLabels: {
                  enabled: false
                },
                colors: ['#FF9800', '#00BCD4', '#9C27B0', '#F44336', '#2196F3', '#4CAF50'],
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "Mei",
                    "Jun",
                    "Jul",
                    "Agu",
                    "Sep",
                    "Okt",
                    "Nov",
                    "Des"
                  ]
                }
              }
            }
          }
        })
      },
      async fetchCount () {
        this.process.dashboard = true

        await get(`admin/dashboard/total`)
        .then(response => {
          let res = response.data

          this.process.dashboard = false

          if (res.status === 200) {
            this.count = res.results.data

            this.list.todo = [
              // {
              //   name: 'Pegawai',
              //   count: this.count.total_pegawai,
              //   icon: 'mdi-account-group-outline'
              // },
              {
                name: 'Data Sisa Cuti',
                count: this.count.total_sisa_cuti,
                icon: 'mdi-calendar-month-outline'
              },
              {
                name: 'Ajuan Izin Cuti',
                count: this.count.total_pengajuan_cuti,
                icon: 'mdi-file-document-edit-outline'
              },
              {
                name: 'Izin & Cuti Disetujui',
                count: this.count.total_cuti_approved,
                icon: 'mdi-file-document-check-outline'
              },
              {
                name: 'Izin & Cuti Ditolak',
                count: this.count.total_cuti_rejected,
                icon: 'mdi-file-document-remove-outline'
              }
            ]
          }
        })
      },
      async fetchAnnouncement () {
        this.process.announcement = true

        let params = {
          limit: 1
        }

        await get(`admin/announcement`, { params })
        .then(response => {
          let res = response.data

          this.process.announcement = false

          if (res.status === 200) {
            this.list.announcement = res.results.data
          }
        })
      },
      updateTime () {
        let cd = new Date()

        this.clock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2)
      },
      zeroPadding (num, digit) {
        let zero = ''

        for(let i = 0; i < digit; i++) {
          zero += '0'
        }
        return (zero + num).slice(-digit)
      }
    }
  }
</script>